import * as React from "react";
import { useHistory } from "react-router";

import { FcbStatutSocialGridDto, StatutSocialApi, StatutSocialSearch, EBooleanSearchTypes } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton, SearchTablePage, ViewButton } from "../../../../../components";
import { useAbortableApiServiceFactory, useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import styled from "styled-components";

interface IStatutSocialListPageProps {}
const ButtonContainer = styled.div`
  display: flex;
`;
export const StatutSocialListPage: React.FunctionComponent<IStatutSocialListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(StatutSocialApi);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbStatutSocialGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.statutSocial}/${row.idstatutSocial}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.statutSocial}/${row.idstatutSocial}/detail/edit`)}
            />
          </ButtonContainer>
        )
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      }
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => history.push(`${ERoutes.statutSocial}/0/detail/edit`), [history]);

  const getCriteriasFn = React.useCallback(() => api.statutSocialGetSearchCriterias({ includeListsValues: true }), [
    api
  ]);

  const apiFactory = useAbortableApiServiceFactory(StatutSocialApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (nextSearch?: StatutSocialSearch) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.statutSocialBaseSearch({ StatutSocialSearch: nextSearch });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      addFunc={addItemFunction}
      breadCrumbs={[{ text: t(ETLCodes.StatutsSociaux), route: ERoutes.statutSocial }]}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    />
  );
};
